import Vue from 'vue'
import App from './App.vue'

import Money from './plugins/Money'
import MomentVue from './plugins/MomentVue'
import EventBus from './plugins/EventBus'
import StringUtils from './plugins/StringUtils'
import Filters from './plugins/filters/'

import VModal from 'vue-js-modal'
import VueDatepickerLocal from "vue-datepicker-local";
import VueMask from 'v-mask'
import BootstrapVue from 'bootstrap-vue'

import store from './store'
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/container.less'
import './assets/js/bank-validator'
import './assets/js/arautos-bank-validator'

import lang from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
locale.use(lang)

import VueSocketio from 'vue-socket.io'
import SocketIO from 'socket.io-client'

import { Loading, MessageBox, Message, Notification, Slider, Steps, Step, Radio, RadioGroup, Checkbox, CheckboxGroup } from 'element-ui'

import { BASE_URL } from './service/ServiceURL'

import VueApollo from 'vue-apollo'
import apolloProvider from './graphql'

import VeeValidate from 'vee-validate'

Vue.use(VueApollo)

Vue.use(VeeValidate);

Vue.use(new VueSocketio({
  debug: false,
  connection: SocketIO(BASE_URL, {
    transports: ['websocket', 'polling']
  })
}));

Vue.use(VueDatepickerLocal)
Vue.use(BootstrapVue);
Vue.use(VModal)
Vue.use(VueMask)
Vue.use(Money)
Vue.use(MomentVue)
Vue.use(EventBus)
Vue.use(StringUtils)
Vue.use(Filters)

Vue.use(Loading.directive)
Vue.use(Slider)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.config.errorHandler = (error, vm, info) => {
	console.log("Ops, ocorreu um erro")
	console.log('ERROR', error)
	console.log('VM', vm)
	console.log('INFO', info)
}

Vue.config.productionTip = true;

new Vue({
  el: '#app',
  apolloProvider,
	store,
  router,
	template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js